import { render, staticRenderFns } from "./BannerShortcutEdit.vue?vue&type=template&id=713754a4&"
import script from "./BannerShortcutEdit.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports